module.exports = __webpack_public_path__ + "static/media/redistribute.6cff59f5.svg";